import { Fragment, useEffect, useRef, useState } from "react";
import { UserService as Service } from "./UserService";

import { useToolbar } from "../../../../shared/hooks/Toolbar";
import { useDataTable } from "../../../../shared/hooks/DataTable";
import { useDialogCrup } from "../../../../shared/hooks/DialogCrup";
import { RoleService } from "../nhom-quyen/RoleService";
import { TenantCompanyService } from "../../doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService";
import { useForm } from "../../../../shared/hooks/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { PermissionDialog } from "./PermissionDialog";
import { ToastService } from "../../../../AppToast";
import { UserPermisionDataAppService} from "./UserPermisionDataAppService";
import { ConfirmDialogService} from '../../../../AppConfirmDialog';
export const List = () => {
  const header = "Người sử dụng";
  const dataKey = "id";
  const company = useRef(null);
  const roles = useRef([]);
  const [idUpdate, setIdUpdate] = useState(null);
  const [display, setDisplay] = useState(false);
  const [displayPermission, setDisplayPermission] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    RoleService.getList({maxResultCount: 1000, skipCount: 0}).then(({ items }) => {
      const _roles = [];
      items.forEach((item) => {
        _roles.push({ value: item.id, label: item.name });
      });
      roles.current = _roles;
    });

    TenantCompanyService.getList({}).then(({ items }) => {
      if (items && items.length) {
        const _company = items[0];
        company.current = _company;
      }
    });
  }, []);

  const setCompanyInfo = (data) => {
    data = { ...data, ...{ company: company.current.name } };
    setValue(data);
  };

  const openCreate = async () => {
    setDisplay(true);
    setIsEdit(false);
    setIdUpdate(null);
    setCompanyInfo({});
  };

  const openUpate = async (item) => {
    setDisplay(true);
    setIsEdit(true);
    setIdUpdate(item.id);
    setCompanyInfo(item);
  };

  const hideUpdatePermissions = () => {
    setDisplayPermission(false); 
    reloadLazyData();
  }

  const {
    render: renderDataTable,
    reloadLazyData,
    selectedItems,
  } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: "userName", header: "Tên truy cập", matchMode: "contains", style: { minWidth: "250px" } },
      { field: "name", header: "Tên người sử dụng", matchMode: "contains", style: { minWidth: "250px" } },
      { field: "roleName", header: "Nhóm quyền", matchMode: "contains", style: { minWidth: "250px" } },
      { field: "email", header: "Email", matchMode: "contains", style: { minWidth: "300px" } },
      {
        field: "hasPermision",
        header: "Phân quyền",
        dataType: "custom",
        style: { minWidth: "200px" },
        customCell(rowData: any): any {
          if (rowData.hasPermision) {
            return <span className = "invoice-status invoice-status-0">Phân quyền theo dữ liệu</span>
          }  

          return <span className = "invoice-status invoice-status-5">Toàn quyền dữ liệu </span>
        },
      },
      {
        field: "viewOtherInvoice",
        header: "Xem",
        dataType: "custom",
        customCell(rowData: any): any {
          return <span>{rowData.viewOtherInvoice ? "C" : "K"}</span>;
        },
      },
      {
        field: "editOtherInvoice",
        header: "Sửa",
        dataType: "custom",
        customCell(rowData: any): any {
          return <span>{rowData.editOtherInvoice ? "C" : "K"}</span>;
        },
      },
      {
        field: "deleteOtherInvoice",
        header: "Xóa",
        dataType: "custom",
        customCell(rowData: any): any {
          return <span>{rowData.deleteOtherInvoice ? "C" : "K"}</span>;
        },
      },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    },
  });

  const {
    render: renderForm,
    setValue,
    getValue,
    valid: formValid,
  } = useForm({
    fields: [
      {
        field: "userName",
        header: "Tên truy cập",
        type: "username",
        disabled: isEdit,
        required: true,
        InputTextProps: { maxLength: 50 },
        className: "md:col-12",
        uppercase: true,
      },
      { field: "name", header: "Tên người sử dụng", required: true, InputTextProps: { maxLength: 200 }, className: "md:col-12" },
      {
        field: "roleId",
        header: "Nhóm quyền",
        required: false,
        type: "Dropdown",
        DropdownProps: { options: roles.current, filter: true },
        className: "md:col-12",
      },
      { field: "email", header: "Email", type: "email", required: true, InputTextProps: { maxLength: 50 }, className: "md:col-12" },
      { field: "mobile", header: "Số điện thoại", InputTextProps: { maxLength: 16 }, className: "md:col-6" },
      { field: "position", header: "Chức vụ", InputTextProps: { maxLength: 400 }, className: "md:col-6" },
      { field: "company", header: "Đơn vị", disabled: true, required: true, InputTextProps: { maxLength: 400 }, className: "md:col-12" },
    ],
  });

  const { renderToolbar } = useToolbar({
    dataKey,
    create: openCreate,
    update: openUpate,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    reloadLazyData,
    selectedItems,
    otherActions: [
      {
        label: "Phân quyền",
        icon: "pi pi-fw pi-lock",
        className: "iam-toolbar",
        disabled: !(selectedItems && selectedItems['id']),
        command: () => {
          if (selectedItems && selectedItems['id']) {
            setDisplayPermission(true);
          } 
        }
      },
      {
        label: "Reset quyền mặc định",
        icon: "pi pi-fw pi-sync",
        className: "iam-toolbar",
        disabled: !(selectedItems && selectedItems['id'] && selectedItems['hasPermision']),
        command: () => {
          if (selectedItems && selectedItems['id'] && selectedItems['hasPermision']) {
            resetPermision();
          } 
        }
      },
    ],
  });

  const handleSubmit = () => {
    if (!submitting && formValid()) {
      let data = getValue();
      let role = roles.current.find((t) => t.value == data.roleId);

      data = {
        ...data,
        ...{
          roleName: role?.name,
          signOtherInvoice: selectedItems['signOtherInvoice'],
          viewOtherInvoice: selectedItems['viewOtherInvoice'],
          editOtherInvoice: selectedItems['editOtherInvoice'],
          deleteOtherInvoice: selectedItems['deleteOtherInvoice'],
        },
      };

      let promise;
      if (idUpdate) {
        promise = Service.update(idUpdate, data);
      } else {
        promise = Service.create(data);
      }

      promise
        .then((data) => {
          setDisplay(false);
          ToastService.success();
          reloadLazyData();
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const resetPermision = () => {
    ConfirmDialogService.confirmResetPermision(() => {
      UserPermisionDataAppService.delete(selectedItems['id']).then(res => {
        reloadLazyData();
      });
    });
  }

  const crupDialog = () => {
    let _header = `Thêm mới ${header}`;
    if (idUpdate) {
      _header = `Chỉnh sửa ${header}`;
    }
    return (
      <Dialog header={_header} visible={display} style={{ width: 500 }} position="top" onHide={() => setDisplay(false)}>
        {renderForm()}

        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm" />
          <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm" />
        </div>
      </Dialog>
    );
  };

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {crupDialog()}
      <PermissionDialog display={displayPermission} hide={() => hideUpdatePermissions()} selectedItems={selectedItems}></PermissionDialog>
    </Fragment>
  );
};
